export default __webpack_public_path__ + "static/media/magzi_brand_gray.b0c9f7ce.svg";